export default {
  name: 'marking--treeMrk',
  apiService: 'shoes',
  apiPath: '/admin/treemrk',
};